module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./angularApp/app/layout/header/header.component.scss
// module id = 1264
// module chunks = 7